module.exports = __webpack_public_path__ + "media/images/bg02-714a7ee25f1420ec177ac4f2e7d1bc96.png";